export default __webpack_public_path__ + "static/media/zrak-rady.58ef86ac.svg";